import { getPermissions } from 'core/flow-control';
import { CUSTOM_REPORT_NAME, OVERVIEW_REPORT_NAME } from 'utils/navigation/navigation-consts';

export const getDefaultPropertyPathname = () => {
    const { enable_custom_property_overview } = getPermissions();

    return enable_custom_property_overview ? CUSTOM_REPORT_NAME : OVERVIEW_REPORT_NAME;
};
